/* eslint-disable import/prefer-default-export */
import { AppStorage } from '@src/utils/storage.helpers'
import { storagePrefix } from '@src/constants/constants'
import type { FilterOption } from '@src/components/head.filter/models'

export interface FilterAccount extends FilterOption {}

const storage = new AppStorage(storagePrefix, sessionStorage)
export interface FilterState {
  currentAccount: FilterAccount
}

const sessionStorageFilter = storage.get('filter') as FilterState
const filter: FilterState =
  sessionStorageFilter || ({ currentAccount: null } as FilterState)

export const defaultState = filter
